module.exports = __webpack_public_path__ + "static/lukowa-1-77ac7606c025ef9c48d32be48422430d.jpg";